import baseStyle from "../../style/styles";
import {Breakpoints} from "../../config";

const style = (theme) => {
    return {
        ...baseStyle(theme),

        searchTitle:
            {
                marginTop: "10px!important",
                marginBottom: "10px!important",
                marginLeft: "0!important",

            },
        searchEvent: {
            ...baseStyle(theme).searchEvent,
            marginBottom: "0",
        },
        drawerPaper:
            {
                top: 80,
                backgroundColor: "#ffffff",
            },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 8px',
            ...theme.mixins.toolbar,
            justifyContent: 'flex-end',
            minHeight: "40px",
        },


        button: {
            padding: 10,
            marginRight: "10px",
            color: "white",
            height: "39px",
            [theme.breakpoints.down(Breakpoints.md)]: {
                height: "32px",
            },
            borderRadius: "6px",
            "&>span": {
                justifyContent: "start",
                fontSize: "16px",
            },
            "& img": {
                margin: "0",
            },

        },

        oesActive:
            {
                backgroundColor: "#6495ed",

                "&:hover": {
                    backgroundColor: "#5486e0",
                },
            },
        oesInactive:
            {
                color: "#6495ed",
                borderColor: "#6495ed",
                "&:hover": {
                    color: "#5486e0",
                    borderColor: "#5486e0",
                    backgroundColor: "transparent"
                },
            },

        xsActive:
            {
                backgroundColor: "#ECBC2D",

                "&:hover": {
                    backgroundColor: "#ecbc2d",
                },
            },
        xsInactive:
            {
                color: "#ECBC2D",
                borderColor: "#ECBC2D",
                "&:hover": {
                    color: "#ecbc2d",
                    borderColor: "#ecbc2d",
                    backgroundColor: "transparent"
                },
            },

        // download statictis button
        exportButton:
            {
                marginLeft: "12px",
            },
        resultTitle:
            {
                color: "#6495ED",
                fontSize: "22px",
                fontWeight: "500",
                lineHeight: "27px",
            },
        resultSubtitle:
            {
                color: "#778899",
                fontSize: "12px",
                marginTop: "10px",
            },
        resultDescription:
            {
                color: "#122042",
                fontSize: "14px",
                lineHeight: "17px",
                marginTop: "10px",
            },

        resultPhoto:
            {
                width: "200px",
                marginRight: "20px",
                "& img":
                    {
                        borderRadius: "5px",

                    }
            },
        resultPhotoPlaceHolder:
            {
                width: "200px",
                height: "100px",
                backgroundColor: "#add8e6",
                borderRadius: "5px",
                backgroundImage: 'url("/images/search-placeholder.png")',
                backgroundSize: "100% 100%",
            },


        stats: {
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "space-between",
            alignItems: "center",
            color: "#ffffff !important",
            width: "149px",
            height: "39px",
            borderRadius: "6px",
            backgroundColor: "#add8e6",
            padding: "0 13px 0 5px",
            "&:hover": {
                backgroundColor: "#9bcfe0 !important",
            },
        },


        textField: {
            "&.search": {
                "&>label": {
                    transform: "translate(14px, 14px) scale(1)",
                },
            },
        },
        "& .react-datepicker-wrapper": {
            "& input": {
                background: "rgb(225, 237, 251)",
                borderRadius: "4px",
                fontSize: "12px",
            },
        },

        topFilters: {
            margin: "0 0 20px",
            fontSize: "12px",
            fontWeight: "500",
            letterSpacing: "0.1em",
            color: "#2a276b",
        },
        paper: {
            overflowX: "auto",
            padding: "0 20px",
            boxShadow: "none",
        },


        tagsWrapper: {
            display: "flex",
            alignItems: "flex-start",
            padding: "12px 12px 0 0 !important",
            "& .ReactTags__tagInput": {
                display: "none",
            },
            "& .ReactTags__tag": {
                padding: "4px 5px",
                borderRadius: "4px",
                backgroundColor: "#778899",
                fontFamily: "Montserrat",
                fontSize: "1rem",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                marginRight: "4px",
                minHeight: "31px",
                marginBottom: "5px",
            },
            "& .ReactTags__selected": {
                display: "flex",
                flexWrap: "wrap",
            },
            "& .ReactTags__remove": {
                cursor: "pointer",
                marginLeft: "10px",
                marginRight: "5px",
                minWidth: "1rem",
                height: "1rem",
                textAlign: "center",
                paddingLeft: "2px",
                color: "transparent",
                backgroundImage: 'url("/images/icons/cross.png")',
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
            },
        },
        participantTag: {
            backgroundColor: "#ECBC2D",
            color: "#ffffff",
            padding: "4px 5px",
            display: "flex",
            fontSize: "1rem",
            minHeight: "31px",
            fontFamily: "Montserrat",
            alignItems: "flex-start",
            marginRight: "4px",
            borderRadius: "4px",
            marginBottom: "5px",
            "& a":
                {
                    height: "20px!important",
                }
        },
        eventTag: {
            backgroundColor: "#6495ed",
            color: "#ffffff",
            padding: "4px 5px",
            display: "flex",
            fontSize: "1rem",
            minHeight: "31px",
            fontFamily: "Montserrat",
            alignItems: "flex-start",
            marginRight: "4px",
            borderRadius: "4px",
            marginBottom: "5px",
            "& a":
                {
                    height: "20px!important",
                }

        },
        filterBlock: {
            "& h3": {
                fontSize: "24px",
                fontWeight: "700",
                padding: "0",
                marginTop: "20px",
                [theme.breakpoints.down(Breakpoints.md)]: {
                    margin: "0",
                },
                color: "rgb(173, 216, 230) ",
                textTransform: "uppercase",
                lineHeight: "1",
                "& a": {
                    fontSize: "12px",
                },
            },
            "& h4": {
                fontSize: "17px",
                fontWeight: "700",
                margin: "10px 0 0",
                color: "#122042",
            },
        },

        participantFilter:
            {
                color: "#ECBC2D!important",
            },
        controlLabel: {
            alignItems: "flex-start",
            "& span": {
                paddingTop: "0",
                paddingBottom: "0",
                color: "#122042",
                fontSize: "14px",
                fontWeight: 400,
                letterSpacing: "0.1em",
            },
            "& svg path": {
                fill: "#ADD8EF",
                fillOpacity: 1,
            },

        },
        count:
            {
                color: "#122042",
                fontSize: "14px",
                letterSpacing: "0.1em",
                fontWeight: "500",
            },
        logo: {
            marginRight: "20px",
            marginTop: "5px",
            "& img": {
                width: "126px",
            },
        },
        checkbox: {
            "& .checkbox": {
                marginRight: "5px",
                width: "20px",
                height: "20px",
                borderRadius: "5px",
                backgroundColor: "#E1EDFB",
                "&--checked": {
                    backgroundImage: "url(/images/icons/icon-check-mark.svg)",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                },
            },
        },
        filter: {
            display: "flex",
            marginTop: "5px",
            "& label": {
                flexGrow: 1,
                color: "rgb(25, 25, 112)",
                fontSize: "12px",
            },
        },
        datesWrapper: {
            display: "flex",
            width: "140px",
            flexDirection: "row",
            justifyContent: "space-between",
            "& > input": {
                fontSize: "10px",
            },
            "& > div": {
                marginBottom: "5px",
            },
        },
        clearAll: {
            color: "#6495ed !important",
            fontSize: "14px",
            fontWeight: "700",
            padding: "4px 5px",
            margin: "0 4px 5px 0",
            border: "1px solid #6495ed",
            borderRadius: "5px",
            minWidth: "130px",
            marginBottom: "5px",
            textAlign: "center",
        },
        exportStatsLink: {
            float: "right",
            fontWeight: "400",
            fontSize: "0.875em",
            marginTop: "3px",
        },
        selectAllLink: {
            marginLeft: "auto",
            textDecoration: "none",
            "& a": {
                fontSize: "12px",
                color: "#778899",
                fontWeight: 400,
                letterSpacing: "0.1em",
            },
        },
        viewAll: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
            minHeight: "10px",
            cursor: "pointer",
            "& a": {
                fontSize: "12px",
                color: "#778899",
                fontWeight: 400,
                letterSpacing: "0.1em",
            },
        },
        calendar:
            {
                minWidth: "none",
                marginBottom: "12px",
                [theme.breakpoints.down("xs")]: {
                    marginRight: "12px",
                },
            },
        calendarDownload: {
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "space-between",
            padding: "0 13px 0 5px",
            alignItems: "center",
            color: "#ffffff !important",
            width: "166px",
            height: "39px",
            borderRadius: "6px",
            backgroundColor: "#77d2b7",
            marginRight: "0 !important",
            "&:hover": {
                backgroundColor: "#67ceaf !important",
            },
        },
        resultsCount:
            {
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                [theme.breakpoints.down(Breakpoints.md)]: {

                    justifyContent: "space-between",
                },
                "& div":
                    {
                        marginRight: "20px",
                    },
            },
        result:
            {
                color: '#778899',
                letterSpacing: '0.1em',
                fontSize: '12px',
                marginBottom: "20px",
                lineHeight: "17px",
                [theme.breakpoints.down(Breakpoints.md)]: {
                    marginBottom: "10px",
                },
                '& p': {
                    display: "flex",
                    alignItems: 'center',
                    margin: 2,
                },
                '& p a': {
                    color: '#191970',
                    display: "flex",
                    alignItems: 'center',
                },
                '& * svg': {
                    alignSelf: "flex-start",
                    marginRight: "10px",
                },
            },
        participantResult:
            {
                paddingLeft: '42px',

                textTransform: 'none !important',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left center',
                lineHeight: "32px",
                backgroundSize: '32px 32px',
            },
        femaleHeader:
            {
                backgroundImage: 'url("data:image/svg+xml;base64,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")',
            },
        maleHeader:
            {
                backgroundImage: 'url("data:image/svg+xml;base64,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")',
            },
        anonymousHeader:
            {
                backgroundImage: 'url("data:image/svg+xml;base64,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")',
            },


    };

};

export default style;
